import React, { ReactNode } from 'react';

import { makeClassNames } from '../../../utils/styles';
import './pager-link.scss';

const classNames = (isCurrentPage: boolean | undefined) =>
  makeClassNames({
    pagerLink: ['pager-link', isCurrentPage && 'pager-link--active'],
  });

export interface IPagerLink {
  label: ReactNode;
  id: number | string;
  onClickCallback?: (x: number | string) => any;
  link?: string;
  isCurrentPage?: boolean;
}

const PagerLink = ({ isCurrentPage, label, link, id, onClickCallback }: IPagerLink) => {
  const cn = classNames(isCurrentPage);

  return !onClickCallback ? (
    <a href={link} className={cn.pagerLink}>
      {label}
    </a>
  ) : (
    <a onClick={() => onClickCallback(id)} className={cn.pagerLink}>
      {label}
    </a>
  );
};

export default PagerLink;
